import Fetch, { serializeQueryString } from 'Util/fetcher';
import { errorLogger } from '@ajaibid/utils';
import { DEFAULT_GET_RESPONSE } from '@config/constanta';
import { mtAccountStatusUrl, mtMarginRatioUrl, mtTradelimitByStockCodeUrl } from './_endpoint';

const fetchGet = (url, { query } = {}) =>
  Fetch.get(`${url}${serializeQueryString(query)}`)
    .then((resp) => resp.json)
    .catch((error) => {
      errorLogger('ERROR_API', error.message, { path: url });
      return { ...DEFAULT_GET_RESPONSE, err_message: error.message };
    });

// MT Account
export const getMtAccountStatus = () => fetchGet(mtAccountStatusUrl);
export const getMtMarginRatio = () => fetchGet(mtMarginRatioUrl);
export const getMtTradelimit = (code) => fetchGet(mtTradelimitByStockCodeUrl(code));
